var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogaMat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#323232;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.25,18A3.75442,3.75442,0,0,0,6,21.75H19A2.7528,2.7528,0,0,0,21.75,19V7A2.7528,2.7528,0,0,0,19,4.25H9.29626A3.73731,3.73731,0,0,0,2.25,6Zm1.5,0A2.25,2.25,0,1,1,6,20.25,2.25278,2.25278,0,0,1,3.75,18ZM19,5.75A1.25116,1.25116,0,0,1,20.25,7V19A1.25116,1.25116,0,0,1,19,20.25H8.98083A3.71357,3.71357,0,0,0,9.75,18V6c0-.08563-.01959-.16583-.02527-.25Zm-13-2A2.25278,2.25278,0,0,1,8.25,6v9.01923a3.67524,3.67524,0,0,0-4.5,0V6A2.25278,2.25278,0,0,1,6,3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaMat);
export default __webpack_public_path__ + "static/media/yoga-mat.fd70869f3f8b4728abf74b7dbb40fc79.svg";
export { ForwardRef as ReactComponent };